export default function (addAccountGroup, $state, toaster, close, getVMCAccountDisplayList) {
    const vm = this;

    vm.model = {};
    vm.form = null;
    vm.save = add;
    vm.closeModal = close;
    vm.retrieveVmcAccounts = retrieveVmcAccounts;
    vm.vmcAccounts = [];
    vm.selectedVmcAccounts = [];

    function add() {
        if (vm.form.$invalid) {
            return;
        }

        vm.model.dealerIds = vm.selectedVmcAccounts.map(x => x.id);

        addAccountGroup(vm.model)
        .then(() => {
            toaster.pop('success', 'The group is successfully created');
            vm.closeModal();
        })
        .catch(error => {
            toaster.pop('error', error.data);
        });
    }

    function retrieveVmcAccounts(filter) {
        getVMCAccountDisplayList(0, filter)
        .then(data => {
            vm.vmcAccounts = data.dealers;
        })
        .catch(() => {
            vm.recordsNotFetched = true;
            vm.errorsOccured = true;
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/accountGroups/controllers/add/addAccountGroupCtrl.js